import React from "react";
import ReactPlayer from "react-player";
import { FaBars } from "react-icons/fa";
import UserHeader from "../../components/Header/UserHeader/UserHeader";
import { awsSignIn, authData } from "../../redux/auth/authSlice";
import { useSelector, useDispatch } from "react-redux";
import { Constants } from "../../config/constants";
import config from "../../config/aws-exports";

function QuickTour({ handleToggleSidebar }) {
  let userDetails = useSelector(authData);
  return (
    <div style={{ width: "100%", padding: "2rem",}}>
      <div>
        <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
          <FaBars />
        </div>
        <UserHeader />
        <ReactPlayer
          url={`https://${
            Constants.DOMAIN
          }/${config.aws_org_id.toLowerCase()}-resources/videos/QuickTour2.mp4`}
          controls={true}
          width="90%"
          height="90%"
          style={{ margin: "auto" }}
        />
      </div>
    </div>
  );
}

export default QuickTour;
